import { environment } from '../../environments/environment';
import { UserProfileService } from '../services/user-profile.service';

export const BEARER_PREFIX = 'Bearer';

export function initKeycloak(userProfileService: UserProfileService): () => Promise<void> {
  return () =>
    userProfileService.initKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'login-required',
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/keycloak/silent-check-sso.html`,
        silentCheckSsoFallback: false,
      },
      loadUserProfileAtStartUp: true,
      enableBearerInterceptor: true,
      bearerPrefix: BEARER_PREFIX,
    });
}
